import type { Element } from "React";
type Props = {
  className?: string;
};

const LogoGamcare = (props: Props): Element<"svg"> => (
  <svg
    version="1.1"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    className={props.className}
    viewBox="0 0 341 378"
  >
    <g id="Layer_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_359297618992">
        <g>
          <path
            style={{
              fill: "black",
            }}
            d="M158 0l159 0c13,0 23,11 23,24l0 251c0,13 -10,23 -23,23l-159 0 0 -298z"
          />
          <path
            style={{
              fill: "white",
            }}
            d="M158 254l0 -30c6,1 11,1 17,1 34,0 64,-9 86,-24l0 0 -43 2c-5,1 -8,-1 -11,-4 -3,-3 -5,-6 -4,-11l0 0c0,-8 6,-13 14,-13l103 0c5,0 9,2 13,7 3,4 4,9 2,14l-16 60c-3,9 -12,15 -22,13l-5 -1c-5,-1 -9,-4 -12,-9 -3,-4 -4,-10 -2,-15l7 -18 0 0c-28,17 -67,28 -109,28 -6,0 -12,0 -18,0zm0 -185l0 -21c6,0 12,0 18,0 37,0 72,8 99,23 4,2 6,5 6,9 1,4 0,7 -3,10l-2 1c-4,4 -10,5 -15,2 -22,-15 -52,-25 -86,-25 -6,0 -11,1 -17,1z"
          />
          <path
            style={{
              fill: "white",
            }}
            d="M24 0l134 0 0 298 -134 0c-13,0 -24,-10 -24,-23l0 -251c0,-13 11,-24 24,-24z"
          />
          <path
            style={{
              fill: "black",
            }}
            d="M158 48l0 21c-58,5 -103,38 -103,78 0,39 45,72 103,77l0 30c-79,-6 -140,-50 -140,-103 0,-53 61,-97 140,-103z"
          />
        </g>
        <g>
          <path
            style={{
              fill: "black",
            }}
            d="M55 350l-32 0 0 8 23 0c-1,3 -4,7 -7,9 -3,2 -7,4 -12,3 -19,-2 -23,-28 -7,-37 5,-3 13,-3 19,1 7,4 -2,4 13,4 -1,-5 -7,-11 -12,-13 -7,-2 -15,-2 -22,0 -10,5 -19,17 -15,33 3,12 15,22 30,20 10,-2 17,-9 20,-17 1,-2 3,-8 2,-11z"
          />
          <g>
            <path
              style={{
                fill: "black",
              }}
              d="M281 349l0 -13c6,0 12,0 12,6 0,7 -6,7 -12,7zm-13 28l13 0 0 -17c1,1 9,15 10,17l16 0c-1,-1 -11,-15 -13,-18 2,-1 4,-1 7,-4 1,-1 3,-3 4,-6 3,-10 -1,-24 -16,-24 -6,-1 -14,-1 -21,-1l0 53z"
            />
            <path
              style={{
                fill: "black",
              }}
              d="M218 357c-18,0 -12,-1 -16,4 -4,3 -8,5 -14,3 -13,-4 -13,-24 1,-27 5,-1 9,0 13,4 4,4 -2,3 16,3 0,-3 -2,-7 -4,-9 -5,-8 -14,-12 -25,-11 -13,1 -24,12 -24,26 0,15 10,26 23,28 11,1 20,-3 26,-12 1,-2 4,-6 4,-9z"
            />
            <path
              style={{
                fill: "black",
              }}
              d="M106 377l7 0 0 -45c1,1 11,29 12,34 1,2 4,10 5,11l5 0c2,-5 6,-17 8,-23 2,-3 3,-7 5,-11l4 -11 -1 45 8 0 0 -53 -12 0c-1,5 -9,25 -11,31 0,1 -3,9 -4,10l-15 -40 -11 -1 0 53z"
            />
            <path
              style={{
                fill: "black",
              }}
              d="M241 342c0,1 5,16 5,16l-10 0 5 -16zm-25 35l13 0 3 -8 17 0 3 8 14 0c0,-1 -9,-24 -10,-26 -2,-5 -3,-9 -5,-13 -1,-3 -4,-12 -5,-14l-10 0 -10 27c-2,3 -10,24 -10,26z"
            />
            <path
              style={{
                fill: "black",
              }}
              d="M340 344l-15 1 0 -9 15 0c0,-1 0,-10 0,-11l-28 0 0 52 28 0 0 -12 -15 0 0 -9 15 0 0 -12z"
            />
            <path
              style={{
                fill: "black",
              }}
              d="M78 335c0,1 7,18 7,19l-15 0c0,-1 7,-18 8,-19zm-25 42l8 0 6 -15 21 0c1,2 2,5 3,7 0,2 2,7 3,8l8 0c0,-2 -9,-23 -10,-26 -2,-3 -10,-25 -11,-27l-7 0 -21 53z"
            />
            <path
              style={{
                fill: "black",
              }}
              d="M340 344l0 12 -15 0 0 9 15 0 0 12 -28 0 0 -52 28 0c0,1 0,10 0,11 1,0 1,0 1,-3 0,-2 0,-7 -1,-9l-28 0c0,1 -1,51 0,53 2,0 27,0 28,0l1 -12 -16 0 0 -9 15 0c1,-1 1,-4 1,-6 0,-1 0,-5 -1,-6z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LogoGamcare;
